import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import AxiosInstance from "../Home/AxiosInstance";

const AddInternship = () => {
  const [formData, setFormData] = useState({
    role: "",
    job_description: "",
    skills: "",
    stipend: "",
    duration: "",
    location: "",
    department: "",
    education: "",
    work_mode: "",
    internship_type: "",
    vacancies: "",
    apply_by: "",
    start_date: "",
    end_date: "",
    status: "Open"
  });

  const [educationOptions, setEducationOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isCloseHovered, setIsCloseHovered] = useState(false);

  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const companyId = localStorage.getItem("companyId");

  useEffect(() => {
    AxiosInstance.get("companies/educations/")
      .then((res) => {
        setEducationOptions(Array.isArray(res.data) ? res.data : []);
      })
      .catch(() => setEducationOptions([]));

    AxiosInstance.get("companies/departments/")
      .then((res) => {
        setDepartmentOptions(Array.isArray(res.data) ? res.data : []);
      })
      .catch(() => setDepartmentOptions([]));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setIsLoading(true);

    if (!userId || !companyId) {
      setErrorMessage("User ID or Company ID not found.");
      setIsLoading(false);
      return;
    }

    const newInternship = {
      ...formData,
      user: parseInt(userId),
      company: parseInt(companyId)
    };

    try {
      const res = await AxiosInstance.post(
        "companies/internship/",
        newInternship
      );
      if (res.status === 201) {
        alert("Internship added successfully!");
        navigate(-1);
      } else {
        setErrorMessage("Failed to add internship.");
      }
    } catch (error) {
      console.error("Error adding internship:", error);
      setErrorMessage("Something went wrong. Please check the form.");
    } finally {
      setIsLoading(false);
    }
  };

  const closeModal = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="modal-backdrop fade show"></div>
      <div
        className="modal d-block"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
        style={{ backgroundColor: "rgba(0,0,0,0.3)" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content" style={{ maxHeight: "90vh" }}>
            <div className="modal-header">
              <h5 className="modal-title">Add Internship</h5>
              <button
                type="button"
                className="btn p-0 border-0 ms-auto"
                aria-label="Close"
                onClick={closeModal}
                disabled={isLoading}
                onMouseEnter={() => setIsCloseHovered(true)}
                onMouseLeave={() => setIsCloseHovered(false)}
                style={{
                  color: isCloseHovered ? "#dc3545" : "#000",
                  lineHeight: 1,
                  transition: "color 0.2s"
                }}
              >
                <IoClose size={24} />
              </button>
            </div>

            <div
              className="modal-body overflow-auto"
              style={{ maxHeight: "65vh", paddingRight: "15px" }}
            >
              {errorMessage && (
                <div className="alert alert-danger">{errorMessage}</div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Role:</label>
                    <input
                      type="text"
                      className="form-control"
                      name="role"
                      value={formData.role}
                      onChange={handleChange}
                      required
                      disabled={isLoading}
                    />
                  </div>

                  <div className="mb-3 col-md-6">
                    <label className="form-label">Location:</label>
                    <input
                      type="text"
                      className="form-control"
                      name="location"
                      value={formData.location}
                      onChange={handleChange}
                      required
                      disabled={isLoading}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Stipend:</label>
                    <input
                      type="text"
                      className="form-control"
                      name="stipend"
                      value={formData.stipend}
                      onChange={handleChange}
                      required
                      disabled={isLoading}
                    />
                  </div>

                  <div className="mb-3 col-md-6">
                    <label className="form-label">Duration:</label>
                    <input
                      type="text"
                      className="form-control"
                      name="duration"
                      value={formData.duration}
                      onChange={handleChange}
                      required
                      disabled={isLoading}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Department:</label>
                    <select
                      className="form-select"
                      name="department"
                      value={formData.department}
                      onChange={handleChange}
                      required
                      disabled={isLoading}
                    >
                      <option value="">Select department</option>
                      {departmentOptions.map((dept) => (
                        <option
                          key={dept.department_id}
                          value={dept.department_name}
                        >
                          {dept.department_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3 col-md-6">
                    <label className="form-label">Education:</label>
                    <select
                      className="form-select"
                      name="education"
                      value={formData.education}
                      onChange={handleChange}
                      required
                      disabled={isLoading}
                    >
                      <option value="">Select education</option>
                      {educationOptions.map((edu) => (
                        <option
                          key={edu.education_id}
                          value={edu.qualification}
                        >
                          {edu.qualification}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Job Description:</label>
                  <textarea
                    className="form-control"
                    name="job_description"
                    value={formData.job_description}
                    onChange={handleChange}
                    rows="3"
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Skills:</label>
                  <textarea
                    className="form-control"
                    name="skills"
                    value={formData.skills}
                    onChange={handleChange}
                    rows="3"
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="row">
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Vacancies:</label>
                    <input
                      type="number"
                      className="form-control"
                      name="vacancies"
                      value={formData.vacancies}
                      onChange={handleChange}
                      required
                      disabled={isLoading}
                    />
                  </div>

                  <div className="mb-3 col-md-6">
                    <label className="form-label">Apply By:</label>
                    <input
                      type="date"
                      className="form-control"
                      name="apply_by"
                      value={formData.apply_by}
                      onChange={handleChange}
                      required
                      disabled={isLoading}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Start Date:</label>
                    <input
                      type="date"
                      className="form-control"
                      name="start_date"
                      value={formData.start_date}
                      onChange={handleChange}
                      required
                      disabled={isLoading}
                    />
                  </div>

                  <div className="mb-3 col-md-6">
                    <label className="form-label">End Date:</label>
                    <input
                      type="date"
                      className="form-control"
                      name="end_date"
                      value={formData.end_date}
                      onChange={handleChange}
                      required
                      disabled={isLoading}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Work Mode:</label>
                    <select
                      className="form-select"
                      name="work_mode"
                      value={formData.work_mode}
                      onChange={handleChange}
                      disabled={isLoading}
                      required
                    >
                      <option value="" disabled>Select Work Mode</option>
                      <option value="Remote">Remote</option>
                      <option value="Hybrid">Hybrid</option>
                      <option value="Onsite">Onsite</option>
                    </select>
                  </div>

                  <div className="mb-3 col-md-6">
                    <label className="form-label">Internship Type:</label>
                    <select
                      className="form-select"
                      name="internship_type"
                      value={formData.internship_type}
                      onChange={handleChange}
                      disabled={isLoading}
                      required
                    >
                      <option value="" disabled>Select Type</option>
                      <option value="Full Time">Full Time</option>
                      <option value="Part Time">Part Time</option>
                    </select>
                  </div>
                </div>

                <div className="row">
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Status:</label>
                    <select
                      className="form-select"
                      name="status"
                      value={formData.status}
                      onChange={handleChange}
                      disabled={isLoading}
                      required
                    >
                      <option value="Open">Open</option>
                      <option value="Closed">Closed</option>
                      <option value="Cancelled">Cancelled</option>
                    </select>
                  </div>

                </div>

                {/* Action Buttons */}
                <div className="d-flex justify-content-end mt-3">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={closeModal}
                    disabled={isLoading}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isLoading}
                  >
                    {isLoading ? "Saving..." : "Save Internship"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddInternship;
